import React from 'react';
import './Icon.css';

import iconData from './data';

const icon = ( props ) => {
	let icon = null;
	
	if( props.icon ) {
		const iconPath = props.icon.split( '.' );
		if( iconPath.length === 2 ) {
			icon = iconData[ iconPath[ 0 ] ][ iconPath[ 1 ] ];
		}
		else {
			icon = iconData.other[ iconPath[ 0 ] ];
		}
	}
	
	let iconViewBox = '0 0 0 0';
	let svgCode = '';
	let iconStyles = '';
	let iconTitle = '';
	
	if( icon ) {
		iconViewBox = '0 0 ' + icon.size.w + ' ' + icon.size.h;
		
		if( props.title ) {
			iconTitle = '<title>' + props.title + '</title>';
		}
		else {
			iconTitle = '<title>' + icon.title + '</title>';
		}
		
		if( icon.styles ) {
			iconStyles = '<style>' + icon.styles.map( style => ( style.selectors + '{' + style.properties + '}' ) ).join( '' ) + '</style>';
		}
		
		if( icon.svg ) {
			if( props.gradient ) {
				const gradientID = '#gradient-' + props.gradient.replace( /\s/g, '-' );
				const maskID = 'mask-' + icon.title.replace( /\s/g, '-' );
				iconStyles = '<defs>' + iconStyles + '<mask id="' + maskID + '" x="0" y="0" width="' + icon.size.w + '" height="' + icon.size.h + '" maskUnits="userSpaceOnUse">' + icon.svg + '</mask></defs>';
				svgCode = '<g style="mask:url(#' + maskID + ')"><rect style="fill:url(' + gradientID + ')" width="' + icon.size.w + '" height="' + icon.size.h + '" /></g>';
			}
			else {
				iconStyles = '<defs>' + iconStyles + '</defs>';
				svgCode = '<g>' + icon.svg + '</g>';
			}
		}
	}
	
	const iconSVG = {
		__html: iconTitle + iconStyles + svgCode
	};
	
	return (
		<div className="Icon" style={ props.style }>
			<svg className={ props.className } xmlns="http://www.w3.org/2000/svg" viewBox={ iconViewBox } dangerouslySetInnerHTML={ iconSVG } />
		</div>
	);
};

export default icon;



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js